<template>
  <div class="local-store-list">
    <div
      v-for="store in markers"
      :key="`${store.infoText.name} ${store.infoText.street}`"
      class="store"
    >
      <div class="local-list-grid" @click="emitLocation(store)">
        <div id="local-marker-cell" class="local-store-list-cell">
          <img
            src="https://assets.vendie.io/logos/marker-alt.jpg"
            class="location-map-marker"
          />
        </div>
        <div id="local-details-cell" class="local-store-list-cell">
          <div class="local-list-name">{{ store.infoText.name }}</div>
          <div>{{ store.infoText.street }}</div>
          <div>{{ store.infoText.city }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'LocalOfflineMapStoreList',
  props: {
    markers: Array,
  },
  methods: {
    emitLocation(store) {
      this.$emit('storeSelected', { ...store }) // ... because otherwise it's an observer object
    },
  },
}
</script>

<style scoped>
.local-store-list {
  border: 1px solid #eee;
  height: 250px;
  overflow-y: scroll;
  --logo-padding: 10px;
}

.store-info,
.store-directions {
  text-align: center;
}

.store-directions i {
  font-size: 65px;
  color: #1c61b2;
}

/* b */
.local-list-grid {
  display: grid;

  grid-template-rows: 1fr;
  grid-template-columns: 40px auto;

  gap: 0px;
  height: 100%;
  align-items: center;

  cursor: pointer;
  border-bottom: 1px solid #cdcdcd;
}

.local-list-grid:hover {
  box-shadow: 0 3px 15px -2px rgb(0 0 0 / 12%);
}

.local-list-grid p {
  margin-bottom: unset;
}

.local-list-name {
  border-bottom: 1px dashed;
  font-weight: bold;
  display: inline-block;
}

#local-marker-cell {
  grid-row-start: 1;
  grid-column-start: 1;

  grid-row-end: 2;
  grid-column-end: 2;
}
#local-details-cell {
  grid-row-start: 1;
  grid-column-start: 2;

  grid-row-end: 2;
  grid-column-end: 2;
}

.slim-hr {
  margin-top: 0px;
  margin-bottom: 0px;
}

.local-store-list-cell {
  padding: 10px var(--logo-padding);
}

.location-map-marker {
  width: 32px;
}

/* w3 scrollbar */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
